import { useMemo } from 'react';
import { useWeb3React } from '@web3-react/core';
import {
    LeaderboardDto,
    SortDirection,
    ActiveSort,
} from '../../context/leaderboard/leaderboardTypes';
import useLeaderboadState from '../../context/leaderboard/useLeaderboardState';

let cachedRankings: LeaderboardDto[] | null = null;

const generateMockRankings = (count: number): LeaderboardDto[] => {
    if (cachedRankings) return cachedRankings;

    const rankings: LeaderboardDto[] = [];

    for (let i = 0; i < count; i++) {
        const totalVolume = Math.random() * 5_000_000 + 50_000;
        const totalSize = Math.random() * 500_000 + 10_000;
        const totalMargin = Math.random() * 200_000 + 5_000;
        const realizedPnL = (Math.random() * 2 - 0.8) * 100_000;
        const wins = Math.floor(Math.random() * 500) + 10;
        const losses = Math.floor(Math.random() * 300) + 5;
        const realizedPnLPercentage = (realizedPnL / totalMargin) * 100;

        const hex = (n: number) => n.toString(16).padStart(2, '0');
        const address =
            '0x' +
            Array.from({ length: 20 }, () => hex(Math.floor(Math.random() * 256))).join(
                ''
            );

        rankings.push({
            userId: address,
            totalSize: totalSize.toFixed(2),
            totalVolume: totalVolume.toFixed(2),
            totalMargin: totalMargin.toFixed(2),
            realizedPnL: realizedPnL.toFixed(2),
            realizedPnLPercentage: realizedPnLPercentage.toFixed(2),
            losses,
            wins,
        });
    }

    cachedRankings = rankings;
    return rankings;
};

const sortData = (a: LeaderboardDto, b: LeaderboardDto, sort: ActiveSort) => {
    const direction = sort.direction === SortDirection.ASC ? 1 : -1;
    const aValue = parseFloat(a[sort.sortKey].toString());
    const bValue = parseFloat(b[sort.sortKey].toString());
    return (aValue - bValue) * direction;
};

const useMockUserRankings = (sort?: ActiveSort) => {
    const { account } = useWeb3React();
    const { activeSort } = useLeaderboadState();

    const userRankings = useMemo(() => {
        return generateMockRankings(50);
    }, []);

    const userData = useMemo(() => {
        if (!account || !userRankings) return;

        const sortBy = sort ?? activeSort;

        const rank = userRankings
            .sort((a, b) => sortData(a, b, sortBy))
            .findIndex(({ userId }) => userId.toLowerCase() === account.toLowerCase());

        if (rank === -1) return;

        return { ...userRankings[rank], rank };
    }, [account, userRankings, activeSort, sort]);

    return {
        hasNextPage: false,
        userRankings: userRankings
            ? userRankings.sort((a, b) => sortData(a, b, activeSort))
            : undefined,
        userData,
        isLoading: false,
        error: undefined,
    };
};

export default useMockUserRankings;
